<style lang="less" scoped>
    @import "../../../../../styles/reset.less";
    @import "../../../../../styles/common-table-list.less";
</style>
<template>
    <div class="center-table-list">
        <div class="table-list">
            <div class="table-list-title" style="justify-content: space-between">
                <span class="myTitle">{{ realNameStatus == 'un_real_name' ? '' : submitType == 'person' ? '个人' : submitType == 'enterprise' ? '企业' : '' }}实名认证</span>
                <router-link v-if="auditStatus == 'reject_real_name'"
                             class="btn-84 addBtn"
                             :to="submitType == 'enterprise' ? '/enterpriseAuthentication1?id=' + registerId : '/personalAuthentication?id=' + registerId ">
                    修改后提交
                </router-link>
            </div>
            <!--       无实名认证     -->
            <div v-if="realNameStatus == 'un_real_name' " class="selective_authentication">
                <div class="authentication_type clearfix">
                    <div class="authentication_item fl">
                        <div class="authentication_title">
                            AUTHENTICATION
                            <div class="authentication_title_group">
                                <h2 class="authentication_subheading">个人认证</h2>
                                <h3 class="authentication_msg">PERSONAL AUTHENTICATION</h3>
                            </div>
                        </div>
                         <button class="authentication_btn" @click="pushRouterpre">认证</button>
                        <!-- <router-link class="authentication_btn" to="/personalAuthentication">认证</router-link> -->
                        <img class="authentication_img fr" src="./images/personal.png" alt='版权登记'>
                    </div>
                    <div class="authentication_item fl">
                        <div class="authentication_title">
                            AUTHENTICATION
                            <div class="authentication_title_group">
                                <h2 class="authentication_subheading">企业认证</h2>
                                <h3 class="authentication_msg">ENTERPRISE CERTIFICATION</h3>
                            </div>
                        </div>
                        <div class="authentication_item_msg">
                            <button class="authentication_btn" @click="pushRouter">认证</button>
                            <!-- <router-link class="authentication_btn" to="/enterpriseAuthentication1">认证</router-link> -->
                            <img class="authentication_img fr" src="./images/enterprise.png" alt='版权登记'>
                        </div>
                    </div>
                </div>
                <div class="reminder">
                    <div class="reminder_title">温馨提示：</div>
                    <ul class="reminder_group">
                        <li class="reminder_item">1、每个账号仅可关联一个实名个人或一个企业；</li>
                        <li class="reminder_item">2、个人认证：需要提交个人身份证复印件进行确认您的身份，用于确权、版权登记等平台业务的授权；</li>
                        <li class="reminder_item">3、企业认证：您需要提交企业营业执照、企业授权书；</li>
                    </ul>
                </div>
            </div>

            <!--       有实名认证    -->
            <div v-else class="stateful">
                <!--       横幅状态        -->
                <div v-if=" auditStatus!='' " :class="auditStatus == 'reject_real_name' ? 'audit_status error' : auditStatus == 'complete_real_name' ? 'audit_status complete' : 'audit_status being'">
                    <span class="audit_text">{{ auditStatus == 'reject_real_name' ? '审核失败' : auditStatus == 'complete_real_name' ? '审核通过' : '审核中'  }}</span>
                </div>
                <div v-if="auditStatus == 'reject_real_name'" style="color:red;font-size:16px;margin-left:35px;margin-top:20px;">
                    <i class="el-icon-warning" style="color:red;font-size:16px;margin-right:10px;"></i>驳回原因:{{remarks}}
                </div>
                <!--       已提交-个人认证     -->
                <div v-if="submitType == 'person' " class="personal_state">
                    <div class="main_group">
                        <li class="main_item">
                            <span class="item_title">姓名：</span>
                            <div class="item_content">
                                <i-input v-model="name" disabled></i-input>
                            </div>
                        </li>
                        <li class="main_item">
                            <span class="item_title">证件号：</span>
                            <div class="item_content">
                                <i-input v-model="identityNumber" disabled></i-input>
                            </div>
                        </li>
                        <li class="main_item" style="align-items:center">
                            <span class="item_title">上传证件：</span>
                            <div class="item_content" style="flex: inherit;">
                                <div v-if="attachExpired!='1'" class="img_group">
                                    <img class="id_card" v-for="(item,index) in photoArr" :key="index"
                                         :src="item"
                                         alt='版权登记'>
                                </div>
                                <div v-else>
                                    <div class="upload_group">
                                        <Upload
                                                type="drag"
                                                name="poUpload"
                                                :data="frontalRequestData"
                                                :action="this.API_ROOT_UPLOAD + 'bqjvip/ident/addNewPoPic'"
                                                :show-upload-list="false"
                                                :before-upload="frontalUpLoadBefore"
                                                :on-success="frontalUpLoadSuccess"
                                                :on-error="frontalUpLoadError"
                                                :on-exceeded-size="frontalExceededSize"
                                                :max-size="5120"
                                                accept=".jpg,.jpeg,.png"
                                                style="display: inline-block;vertical-align: top;">

                                            <!--  没有图片时  -->
                                            <div v-if="frontalState == -1" class="upload_text">
                                                <!-- <div class="upload_text_add">+</div>
                                                <p>上传正面1</p> -->
                                                <img src='./images/Z.png'/>
                                            </div>

                                            <!--  图片上传时  -->
                                            <div v-else-if="frontalState == 1" class="upload_ing">
                                                <div class="upload_ing_text">识别中...</div>
                                            </div>

                                            <!--  图片上传成功  -->
                                            <div v-else-if="frontalState == 0" class="upload_success">
                                                <img class="upload_success_img"
                                                    :src="frontalPhoto"
                                                    alt='版权登记'>
                                                <div class="upload_success_btn">重新上传</div>
                                            </div>
                                        </Upload>
                                        <Upload
                                                type="drag"
                                                name="poUpload"
                                                :data="reverseRequestData"
                                                :action="this.API_ROOT_UPLOAD + 'bqjvip/ident/addNewPoPic'"
                                                :show-upload-list="false"
                                                :before-upload="reverseUpLoadBefore"
                                                :on-success="reverseUpLoadSuccess"
                                                :on-error="reverseUpLoadError"
                                                :on-exceeded-size="reverseExceededSize"
                                                :max-size="5120"
                                                accept=".jpg,.jpeg,.png"
                                                style="display: inline-block;vertical-align: top;">
                                            <!--  没有图片时  -->
                                            <div v-if="reverseState == -1" class="upload_text">
                                                <img src='./images/F.png'/>
                                                <!-- <div class="upload_text_add">+</div>
                                                <p>上传反面</p> -->
                                            </div>

                                            <!--  图片上传时  -->
                                            <div v-else-if="reverseState == 1" class="upload_ing">
                                                <div class="upload_ing_text">识别中...</div>
                                            </div>

                                            <!--  图片上传成功  -->
                                            <div v-else-if="reverseState == 0" class="upload_success">
                                                <img class="upload_success_img"
                                                    :src="reversePhoto"
                                                    alt='版权登记'>
                                                <div class="upload_success_btn">重新上传</div>
                                            </div>

                                        </Upload>

<!--                                        <Upload
                                        type="drag"
                                        name="poUpload"
                                        :data="handRequestData"
                                        :action="this.API_ROOT_UPLOAD + 'bqjvip/ident/addNewPoPic'"
                                        :show-upload-list="false"
                                        :max-size="10240"
                                        accept=".jpg,.jpeg,.png"
                                        style="display: inline-block; vertical-align: top"
                                        >
                                        &lt;!&ndash;  没有图片时  &ndash;&gt;
                                        <div v-if="holdByHandState == -1" class="upload_text">
                                            <img src="../authentication/images/shouci.png" />
                                        </div>

                                        &lt;!&ndash;  图片上传时  &ndash;&gt;
                                        <div v-else-if="holdByHandState == 1" class="upload_ing">
                                            <div class="upload_ing_text">上传中...</div>
                                        </div>

                                        &lt;!&ndash;  图片上传成功  &ndash;&gt;
                                        <div v-else-if="holdByHandState == 0" class="upload_success">
                                            <img
                                            class="upload_success_img"
                                            :src="idHoldByHandUrl"
                                            alt="版权登记"
                                            />
                                            <div class="upload_success_btn">重新上传</div>
                                        </div>
                                    </Upload>-->
                                    </div>
                                </div>
                            </div>
                            <div v-if="attachExpired=='1'" style="color:red;font-size:16px;margin-left:35px;"><i class="el-icon-warning" style="color:red;font-size:16px;margin-right:10px;"></i>身份证过期，请重新上传</div>
                        </li>
                    </div>
                </div>

                <!--       已提交-企业认证     -->
                <div v-else-if="submitType == 'enterprise' " class="enterprise_state">
                    <div class="main_group">
                        <li class="main_item">
                            <span class="item_title">企业名称：</span>
                            <div class="item_content">
                                <i-input v-model="name" disabled></i-input>
                            </div>
                        </li>
                        <li class="main_item">
                            <span class="item_title">统一社会 信用代码：</span>
                            <div class="item_content">
                                <i-input v-model="identityNumber" disabled></i-input>
                            </div>
                        </li>
                        <li class="main_item">
                            <span class="item_title">有效期：</span>
                            <div class="item_content">
                                <i-input v-model="enterpriseDuration" disabled></i-input>
                            </div>
                        </li>
                        <li class="main_item">
                            <span class="item_title">地址：</span>
                            <div class="item_content">
                                <i-input v-model="enterpriseAddress" disabled></i-input>
                            </div>
                        </li>
                        <li class="main_item">
                            <span class="item_title top_title">营业执照：</span>
                            <div class="item_content">
                                <div v-if="attachExpired!='1'" class="img_group">
                                    <img v-for="(item,index) in photoArr" :key="index" class="license_photo" :src="item" alt='版权登记'/>
                                </div>
                                <div v-else>
                                    <div class="upload_group">
                                        <Upload
                                            type="drag"
                                            name="poUpload"
                                            :data="requestData"
                                            :action="this.API_ROOT_UPLOAD + 'bqjvip/ident/addNewPoPic'"
                                            :show-upload-list="false"
                                            :before-upload="upLoadBefore"
                                            :on-success="upLoadSuccess"
                                            :on-error="upLoadError"
                                            accept=".jpg,.jpeg,.png"
                                            style="display: inline-block;vertical-align: top;">
                                            <!--  没有图片时  -->
                                            <div v-if="licenseStatus == -1" class="upload_text">
                                                <div class="upload_text_add">+</div>
                                            </div>

                                            <!--  图片上传时  -->
                                            <div v-else-if="licenseStatus == 1" class="upload_ing">
                                                <div class="upload_ing_text">识别中...</div>
                                            </div>

                                            <!--  图片上传成功  -->
                                            <div v-else-if="licenseStatus == 0" class="upload_success">
                                                <img class="upload_success_img"
                                                    :src="licensePhoto"
                                                    alt='版权登记'>
                                                <div class="upload_success_btn">重新上传</div>
                                            </div>
                                        </Upload>
                                    </div>
                                </div>
                            </div>
                            <div v-if="attachExpired=='1'" style="color:red;font-size:16px;margin-left:35px;"><i class="el-icon-warning" style="color:red;font-size:16px;margin-right:10px;"></i>营业执照过期，请重新上传</div>
                        </li>
                    </div>
                </div>
            </div>
            <div v-if="submitType == 'person' || submitType == 'enterprise'">
<!--              <div class="table-list-title" style="justify-content: space-between">
                <span class="myTitle">重要联系信息</span>
              </div>
              <div>
                <div class="main_group">
                  <li class="main_item">
                    <span class="item_title">联系地址：</span>
                    <div class="item_content">
                      <i-input v-model="address" disabled></i-input>
                    </div>
                  </li>
                  <li class="main_item">
                    <span class="item_title">邮编：</span>
                    <div class="item_content">
                      <i-input v-model="postCode" disabled></i-input>
                    </div>
                  </li>
                  <li class="main_item">
                    <span class="item_title">联系人：</span>
                    <div class="item_content">
                      <i-input v-model="linkMan" disabled></i-input>
                    </div>
                  </li>
                  <li class="main_item">
                    <span class="item_title">联系电话：</span>
                    <div class="item_content">
                      <i-input v-model="linkPhone" disabled></i-input>
                    </div>
                  </li>
                  <li class="main_item">
                    <span class="item_title">Email：</span>
                    <div class="item_content">
                      <i-input v-model="email" disabled></i-input>
                    </div>
                  </li>
                  <li class="main_item">
                    <span class="item_title">传真：</span>
                    <div class="item_content">
                      <i-input v-model="faxNum" disabled></i-input>
                    </div>
                  </li>
                  <li class="main_item">
                    <span class="item_title">用户所属行业：</span>
                    <div class="item_content">
                      <Select v-model="industryId"  @on-change="changeLevel1" class="item_date_list" style="width: 400px;" disabled>
                        <Option v-for="item in level1List" :value="item.id" :key="item.id">{{ item.value }}</Option>
                      </Select>
                    </div>
                  </li>
                  <li class="main_item">
                    <span class="item_title">用户所属二级行业：</span>
                    <div class="item_content">
                      <Select id="secSel" v-model="secindustryId" class="item_date_list" style="width: 400px;" disabled>
                        &lt;!&ndash;level2list数组里面只有Location_L&ndash;&gt;
                        <Option v-for="item in level2list" :value="item.id" :key="item.id" >{{ item.Location_L}}</Option>
                      </Select>
                    </div>
                  </li>
                  <li class="main_item">
                    <span class="item_title">登办理点：</span>
                    <div class="item_content">
                      <Select class="item_date_list" v-model="belongRegionId" style="width: 400px;" disabled>
                        <Option v-for="(item,index) in belongRegionsData" :value="item.id" :key="item.id">{{item.belongRegionName}}</Option>
                      </Select>
                    </div>
                  </li>
                </div>
              </div>-->
              </div>
          </div>
    </div>
</template>

<script>
import {_findMainObligee, _updatePowerUserIdentity} from "@/api/authentication.js";
    import Cookies from "js-cookie";

    export default {
        metaInfo: {
            title: '实名认证|前海版权综合服务平台',
            meta: [{                 // set meta
                name: 'keyWords',
                content: '版权服务,版权百科,版权,前海版权综合服务平台,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
            }, {
                name: 'Description',
                content: '实名认证,前海版权综合服务平台,人人都是创作者，人人都是版权人。前海版权综合服务平台秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
            }]
        },
        name: "authentication",
        data() {
            return {
                frontalRequestData: {picType: 'idCadeOn'}, //上传身份证正面请求参数
                reverseRequestData: {picType: 'idCadeBack'},
                handRequestData: {picType: 'handImgUrl'},//上传手持身份证参数
                requestData: {picType: 'business'},
                frontalPhoto: '', //身份证正面照片
                reversePhoto: '', //身份证反面照片
                // idHoldByHandUrl: '', //手持身份证
                licensePhoto:'',
                frontalState: -1, //正面身份证上传状态：-1:未上传，1:上传中，0:上传成功
                reverseState: -1, //反面身份证上传状态：-1:未上传，1:上传中，0:上传成功
                holdByHandState: -1, //手持身份证上传状态：-1:未上传，1:上传中，0:上传成功
                licenseStatus: -1,
                registerId: '', //用户唯一id
                realNameStatus: '', //实名状态 un_real_name：未实名
                submitType: '',  //认证类型  person：个人；enterprise：企业
                auditStatus: '',
                name: '', //个人、企业-姓名
                identityNumber: '', //证件号（身份证号、信用代码证）
                enterpriseDuration: '', //企业-营业时间
                enterpriseAddress: '',  //企业-地址
                photoArr: [], //图片数组
                remarks:'',
                attachExpired:'',
                attachment1:'', //正面url
                attachment2:'', //反面url
                attachment3:'', //营业执照url
                startTime: '', //证件开始时间
                endTime: '', //证件结束时间

              address: '',//联系地址
              postCode: '',//邮编
              linkMan: '',//联系人
              linkPhone: '',//联系电话
              email: '',//Email
              faxNum: '',//传真
              industryId: '',//用户所属行业
              secindustryId: '',//用户所属二级行业
              belongRegionId: '',//登办理点
              belongRegionsData: [],//办理点列表

              level2list:[],
              level1List: [
                {
                  id: '1',
                  value: '农、林、牧、渔业',
                  label:[
                    {
                      "id":'0',
                      "Location_L":"无",
                      "isShow":true
                    }
                  ]
                },
                {
                  id: '2',
                  value: '采矿业',
                  label:[
                    {
                      "id":'0',
                      "Location_L":"无",
                      "isShow":true
                    }
                  ]
                },
                {
                  id: '3',
                  value: '制造业',
                  label:[
                    {
                      "id":'21',
                      "Location_L":"食品制造业",
                      "isShow":true
                    },
                    {
                      "id":'22',
                      "Location_L":"酒、饮料和精制茶制造业",
                      "isShow":true
                    },
                    {
                      "id":'23',
                      "Location_L":"纺织服装、服饰业",
                      "isShow":true
                    },
                    {
                      "id":'24',
                      "Location_L":"皮革、毛皮、羽毛及其制品和制鞋业",
                      "isShow":true
                    },
                    {
                      "id":'25',
                      "Location_L":"木材加工和木、竹、藤、棕、草制品业",
                      "isShow":true
                    },
                    {
                      "id":'26',
                      "Location_L":"家具制造业",
                      "isShow":true
                    },
                    {
                      "id":'27',
                      "Location_L":"造纸和纸制品业",
                      "isShow":true
                    },
                    {
                      "id":'28',
                      "Location_L":"印刷和记录媒介复制业",
                      "isShow":true
                    },
                    {
                      "id":'29',
                      "Location_L":"文教、工美、体育和娱乐用品制造业",
                      "isShow":true
                    },
                    {
                      "id":'30',
                      "Location_L":"汽车制造业",
                      "isShow":true
                    },
                    {
                      "id":'31',
                      "Location_L":"计算机、通信和其他电子设备制造业",
                      "isShow":true
                    },
                    {
                      "id":'32',
                      "Location_L":"其他制造业",
                      "isShow":true
                    }
                  ]
                },
                {
                  id: '4',
                  value: '电力、热力、燃气及水生产和供应业',
                  label:[
                    {
                      "id":'0',
                      "Location_L":"无",
                      "isShow":true
                    }
                  ]
                },
                {
                  id: '5',
                  value: '建筑业',
                  label:[
                    {
                      "id":'0',
                      "Location_L":"无",
                      "isShow":true
                    }
                  ]
                },
                {
                  id: '6',
                  value: '批发和零售业',
                  label:[
                    {
                      "id":'0',
                      "Location_L":"无",
                      "isShow":true
                    }
                  ]
                },
                {
                  id: '7',
                  value: '交通运输、仓储和邮政业',
                  label:[
                    {
                      "id":'0',
                      "Location_L":"无",
                      "isShow":true
                    }
                  ]
                },
                {
                  id: '8',
                  value: '住宿和餐营业',
                  label:[
                    {
                      "id":'33',
                      "Location_L":"住宿业",
                      "isShow":true
                    },
                    {
                      "id":'34',
                      "Location_L":"餐饮业",
                      "isShow":true
                    }
                  ]
                },
                {
                  id: '9',
                  value: '信息传输、软件和信息技术服务业',
                  label:[
                    {
                      "id":'0',
                      "Location_L":"无",
                      "isShow":true
                    }
                  ]
                },
                {
                  id: '10',
                  value: '金融业',
                  label:[
                    {
                      "id":'0',
                      "Location_L":"无",
                      "isShow":true
                    }
                  ]
                },
                {
                  id: '11',
                  value: '房地产业',
                  label:[
                    {
                      "id":'0',
                      "Location_L":"无",
                      "isShow":true
                    }
                  ]
                },
                {
                  id: '12',
                  value: '租赁和商务服务业',
                  label:[
                    {
                      "id":'0',
                      "Location_L":"无",
                      "isShow":true
                    }
                  ]
                },
                {
                  id: '13',
                  value: '科学研究和技术服务业',
                  label:[
                    {
                      "id":'0',
                      "Location_L":"无",
                      "isShow":true
                    }
                  ]
                },
                {
                  id: '14',
                  value: '水利、环境和公共设施管理业',
                  label:[
                    {
                      "id":'0',
                      "Location_L":"无",
                      "isShow":true
                    }
                  ]
                },
                {
                  id: '15',
                  value: '居民服务、修理和其他服务业',
                  label:[
                    {
                      "id":'0',
                      "Location_L":"无",
                      "isShow":true
                    }
                  ]
                },
                {
                  id: '16',
                  value: '教育',
                  label:[
                    {
                      "id":'0',
                      "Location_L":"无",
                      "isShow":true
                    }
                  ]
                },
                {
                  id: '17',
                  value: '卫生和社会服务工作',
                  label:[
                    {
                      "id":'0',
                      "Location_L":"无",
                      "isShow":true
                    }
                  ]
                },
                {
                  id: '18',
                  value: '文化、体育和娱乐业',
                  label:[
                    {
                      "id":'35',
                      "Location_L":"新闻和出版业",
                      "isShow":true
                    },
                    {
                      "id":'36',
                      "Location_L":"广播、电视、电影和录音作业",
                      "isShow":true
                    },
                    {
                      "id":'37',
                      "Location_L":"文化艺术业",
                      "isShow":true
                    },
                    {
                      "id":'38',
                      "Location_L":"体育",
                      "isShow":true
                    },
                    {
                      "id":'39',
                      "Location_L":"娱乐业",
                      "isShow":true
                    }
                  ]
                },
                {
                  id: '19',
                  value: '公共管理、社会保障和社会组织',
                  label:[
                    {
                      "id":'0',
                      "Location_L":"无",
                      "isShow":true
                    }
                  ]
                },
                {
                  id: '20',
                  value: '国际组织',
                  label:[
                    {
                      "id":'0',
                      "Location_L":"无",
                      "isShow":true
                    }
                  ]
                }

              ],
            }
        },
        created() {
            if (Cookies.get("userInfo") && Cookies.get("userInfo") != '') {
                var userInfo = JSON.parse(Cookies.get("userInfo"));
                this.realNameStatus = userInfo.realNameStatus;
                this.registerId = userInfo.id;

                /*this.getBelongRegions();*/
                if (this.realNameStatus != 'un_real_name') {
                    this.findMainObligee();
                    // this.findGsfwUser();
                }
            } else {
                this.$router.push("/login");
                return false;
            }
        },
        methods: {
            insertStr(soure, start, newStr) {
                return soure.slice(0, start) + newStr + soure.slice(start);
            },
             /****************上传营业执照钩子函数**************/
            upLoadBefore() {
                this.licenseStatus = 1;
            },

            upLoadSuccess(res) {
                let _this = this;
                if (res.code == 200 && res.result && res.result.reason == '成功') {
                    let result = res.result.result;
                    this.licensePhoto = res.fileUrl;
                    this.attachment3 = res.fileId
                    this.name = result.name;
                    this.identityNumber = result.reg_num;
                    this.enterpriseAddress = result.address ? result.address : '';
                    if (result.regtime && result.regtime != '') {
                        this.licenseAttachStartTime = this.insertStr(this.insertStr(result.regtime, 4, '-'), 7, '-');
                    }
                    if (result.valid_period && result.valid_period != '' && result.valid_period != '长期') {
                        this.dateTypeValue = 1;
                        this.licenseAttachEndTime = this.insertStr(this.insertStr(result.valid_period, 4, '-'), 7, '-');
                    } else {
                        this.licenseAttachEndTime = result.valid_period;
                    }
                    this.enterpriseDuration = this.licenseAttachStartTime + '至' + this.licenseAttachEndTime;
                    this.licenseStatus = 0;
                    if(this.attachment3 != ''){
                        let params = {
                            name:this.name,
                            identityNumber:this.identityNumber,
                            attachment3:this.attachment3,
                            attachStartTime: this.startTime,
                            attachEndTime: this.endTime
                        }
                        _updatePowerUserIdentity(params).then(res => {
                            if(res.code == 200){
                                _this.findMainObligee();
                            }else{
                                toast(res.message);
                            }
                        })
                    }

                } else {
                    this.upLoadError();
                }
            },

            upLoadError() {
                this.licenseFileId = '';
                this.licensePhoto = '';
                this.licenseName = '';
                this.licenseIdentityNo = '';
                this.licenseAttachStartTime = '';
                this.licenseAttachEndTime = '';
                this.licenseAddress = '';
                this.licenseStatus = -1;
                toast('解析失败，请重试');
            },
            /****************身份证正面**************/
            frontalUpLoadBefore() {
                this.frontalState = 1;
            },
            frontalUpLoadSuccess(res) {
                let _this = this;
                if (res.code == 200 && !res.message) {
                    let result = res.result;
                    this.name = result.name;
                    this.attachment1 = res.fileId;
                    this.frontalPhoto = res.fileUrl;
                    this.identityNumber = result.id;
                    this.frontalState = 0;
                    console.log("zhengmian shangchuanwanbi ");
                    if(this.attachment1 != '' && this.attachment2 != ''){
                        let params = {
                            name:this.name,
                            identityNumber:this.identityNumber,
                            attachment1:this.attachment1,
                            attachment2:this.attachment2,
                            attachStartTime: this.startTime,
                            attachEndTime: this.endTime
                        }
                        _updatePowerUserIdentity(params).then(res => {
                            if(res.code == 200){
                                _this.findMainObligee();
                            }else{
                                toast(res.message);
                            }
                        })
                    }
                } else {
                    this.frontalUpLoadError();
                }
            },
            frontalExceededSize() {
                toast('证件大小不得超过5MB');
                this.frontalUpLoadError(true);
            },
            frontalUpLoadError(showToast) {
                this.attachment1 = '';
                this.frontalState = -1;
                if (!showToast) {
                    toast('解析失败，请重试');
                }
            },

            /****************身份证反面**************/
            reverseUpLoadBefore() {
                this.reverseState = 1;
            },
            reverseUpLoadSuccess(res) {
                let _this = this;
                if (res.code == 200 && !res.message) {
                    let result = res.result;
                    this.reversePhoto = res.fileUrl;
                    this.attachment2 = res.fileId;
                    this.startTime = result.validStart;
                    this.endTime = result.validEnd;
                    this.reverseState = 0;
                    console.log("fanmian shangchuanwanbi ");
                    if(this.attachment1 != '' && this.attachment2 != ''){
                        let params = {
                            name:this.name,
                            identityNumber:this.identityNumber,
                            attachment1:this.attachment1,
                            attachment2:this.attachment2,
                            attachStartTime: this.startTime,
                            attachEndTime: this.endTime
                        }
                        _updatePowerUserIdentity(params).then(res => {
                            if(res.code == 200){
                                _this.findMainObligee();
                            }else{
                                toast(res.message);
                            }
                        })
                    }
                } else {
                    this.reverseUpLoadError();
                }
            },
            reverseExceededSize() {
                toast('证件大小不得超过5MB');
                this.reverseUpLoadError(true);
            },
            reverseUpLoadError(showToast) {
                this.attachment2 = '';
                this.reverseState = -1;
                if (!showToast) {
                    toast('解析失败，请重试');
                }
            },
          /*getBelongRegions() {
            _getBelongRegions().then(res => {
              if (res.code == '200') {
                this.belongRegionsData = res.result;
              }else{
                var br = "[{\"belongRegionName\":\"前海版权服务中心\",\"address\":\"甘肃省兰州市城关区雁南路279号科庆综合楼12楼知识产权港公司版权部\",\"id\":1},{\"belongRegionName\":\"兰州文创产业园知识产权服务站\",\"address\":\"\",\"id\":3},{\"belongRegionName\":\"江苏版权登记\",\"address\":\"甘肃省兰州市城关区雁南路279号\",\"id\":4},{\"belongRegionName\":\"甘肃省高校版权登记服务站（甘肃政法大学办理点）\",\"address\":\"甘肃省兰州市安宁西路6号 \",\"id\":6},{\"belongRegionName\":\"北京版权家办理点\",\"address\":\"甘肃省兰州市城关区雁南路279号12层\",\"id\":8},{\"belongRegionName\":\"北京易同信和信息服务\",\"address\":\"甘肃省兰州市城关区雁南路279号\",\"id\":10}]";
                this.belongRegionsData = JSON.parse(br);
              }
            });

          },*/
            /**************************/
            findMainObligee() {
                _findMainObligee().then(res => {
                    if (res.code == 200) {
                        let result = res.result;
                        let submitType = result.obligeeType;
                        this.name = result.name;
                        this.submitType = submitType;
                        this.auditStatus = result.obligeeRealNameStatus;
                        this.identityNumber = result.identityNumber;
                        this.enterpriseDuration = result.attachStartTime + '至' + result.attachEndTime;
                        this.enterpriseAddress = result.address && result.address!='null' ? result.address : '';
                        this.remarks = result.remarks ? result.remarks : ''
                        this.attachExpired = result.attachExpired
                        //企业
                        if (submitType == 'enterprise') {
                            this.photoArr = [];
                            this.photoArr.push(result.attachment3Url);
                            this.licensePhoto = result.attachment3Url;
                            this.licenseStatus = 0
                        }

                        //个人
                        else {
                            this.photoArr = [];
                            // let handImgUrl = result.handImgUrl
                            // this.photoArr.push(result.attachment1Url, result.attachment2Url,handImgUrl);
                            this.photoArr.push(result.attachment1Url, result.attachment2Url);
                            this.frontalPhoto = result.attachment1Url
                            this.reversePhoto = result.attachment2Url
                            // this.idHoldByHandUrl = result.handImgUrl
                            this.frontalState = 0 //正面身份证上传状态：-1:未上传，1:上传中，0:上传成功
                            this.reverseState = 0
                            this.holdByHandState = 0
                        }


                    } else {
                        toast('获取失败，请刷新后重试');
                    }
                }, (err) => {
                    toast('获取失败，请刷新后重试');
                });
            },
            initialLevel2(){
              for(var i = 0;i<this.level1List.length;i++){
                if(this.level1List[i].id == this.industryId){
                  for(var k = 0;k < this.level1List[i].label.length;k++){
                    if(this.level1List[i].label[k].id == this.secindustryId){
                      this.level2list = this.level1List[i].label;
                    }
                  }
                }
              }
            },
            changeLevel1(){
              //循环level1List数组
              for(var i = 0;i<this.level1List.length;i++){
                //如果当前点击的数组value等于他自己当前v-model
                if(this.level1List[i].id == this.industryId){
                  //就把数组label绑定le2list
                  this.level2list = this.level1List[i].label;
                }
              }
            },

            /*findGsfwUser(){
              _findGsfwUser().then(res => {
                if (res.code == 200) {
                  let result = res.result;

                  this.address = result.linkAddress;
                  this.postCode = result.postCode;
                  this.linkMan = result.linkMan;
                  this.linkPhone = result.linkPhone;
                  this.linkMan = result.linkMan;
                  this.email = result.email;
                  this.faxNum = result.faxNum;
                  this.belongRegionId = result.belongRegionId;
                  this.industryId = result.industryId;
                  this.secindustryId = result.secindustryId;
                  this.belongRegionsData = result.belongRegionsData;

                  this.initialLevel2();
                }
              })
            },*/
            pushRouterpre(){
                this.$router.push({ path:'/personalAuthentication' })
            },
            pushRouter(){
                this.$router.push({ path:'/enterpriseAuthentication1' })
            }
        }
    }
</script>

<style scoped lang="less">
    .modifySubmit {
        text-align: center;
        margin-right: 25px;
    }

    .authentication_type {
        margin: 16px 0 0 20px;
    }

    .authentication_type .authentication_item {
        width: 421px;
        height: 240px;
        background: linear-gradient(135deg, rgba(253, 253, 255, 1) 0%, rgba(250, 251, 253, 1) 100%);
        border-radius: 8px;
        margin-right: 25px;
        position: relative;
    }

    .authentication_type .authentication_item:last-child {
        margin-right: 0;
    }

    .authentication_item .authentication_title {
        position: relative;
        font-family: PingFangSC-Regular, PingFang SC;
        font-size: 48px;
        color: #FAF9FB;
        line-height: 1;
    }

    .authentication_title .authentication_title_group {
        position: absolute;
        left: 25px;
        top: 11px;
    }

    .authentication_title .authentication_subheading {
        color: #333333;
        font-size: 16px;
        line-height: 22px;
        font-weight: bold;
    }

    .authentication_title .authentication_msg {
        font-size: 12px;
        font-weight: 400;
        color: #333333;
        line-height: 17px;
        padding-top: 4px;
    }

    .authentication_item .authentication_btn {
        display: block;
        background: #2196F3;
        width: 104px;
        height: 29px;
        line-height: 29px;
        border-radius: 4px;
        text-align: center;
        color: #fff;
        font-size: 12px;
        position: absolute;
        left: 25px;
        bottom: 25px;
        cursor: pointer;
        outline: none;
        border:0;
    }

    .authentication_item .authentication_img {
        margin-right: 19px;
    }

    .reminder {
        padding: 20px 0 0 25px;
        color: #999;
        font-size: 14px;
    }

    .reminder .reminder_group {
        padding-top: 10px;
    }

    .audit_status {
        width: 100%;
        text-align: center;
        height: 50px;
        padding: 15px 0;
        font-size: 14px;
        border: 1px solid #FF8800;
        box-sizing: border-box;
    }

    .audit_status.being {
        color: #FF8800;
        background: #FFFDF9;

        .audit_text:before {
            content: '';
            padding-right: 30px;
            height: 20px;
            background: url(./images/audit_being.png) no-repeat left center;
            background-size: 20px 20px;
            display: inline-block;
            vertical-align: middle;
        }
    }

    .audit_status.complete {
        background: #F9FFF7;
        color: #54D329;
        border-color: #69E140;

        .audit_text:before {
            content: '';
            padding-right: 30px;
            height: 20px;
            background: url(./images/audit_complete.png) no-repeat left center;
            background-size: 20px 20px;
            display: inline-block;
            vertical-align: middle;
        }

    }

    .audit_status.error {
        background: #ffcccc;
        color: #d81e06;
        border-color: #d81e06;

        .audit_text:before {
            content: '';
            padding-right: 30px;
            height: 20px;
            background: url(./images/audit_error.png) no-repeat left center;
            background-size: 20px 20px;
            display: inline-block;
            vertical-align: middle;
        }

    }

    .main_group .main_item {
        display: flex;
        border-bottom: 1px solid #F3F3F3;
        padding: 20px 35px;
        color: #666;
        font-size: 14px;
    }

    .main_group .main_item:last-child {
        /*border-bottom: none;*/
    }

    .main_item .item_title {
        width: 70px;
        align-self: center;
        margin-right: 48px;
    }

    .main_item .item_title.top_title {
        align-self: auto;
    }

    .main_item .item_content {
        flex: 1;
    }

    .myu_upload {
        justify-content: center;
        display: flex;
        flex-direction: column;
        align-items: center;

        p {
            height: 20px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 20px;
            margin-top: 10px;
        }
    }


    /deep/ .ivu-upload {
        width: 180px;
        height: 110px;
        margin-right: 20px;
        display: flex;
    }

    /deep/ .ivu-upload-drag {
        border: 1px solid #CBCBCB;
    }
    .upload_text {
        align-self: center;
        margin: 0 auto;
        color: #999;
        font-size: 12px;
        img{
            width: 162px;
            height: 81px;
            display: block;
            margin: auto;
        }
    }

    .upload_ing {
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, .5);
        display: flex;
    }

    .upload_ing .upload_ing_text {
        color: #fff;
        align-self: center;
        margin: 0 auto;
    }

    .upload_success {
        position: relative;
        width: 100%;
    }

    .upload_success .upload_success_img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .upload_success:after {
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, .5);
        z-index: 2;
    }

    .upload_success .upload_success_btn {
        width: 82px;
        height: 26px;
        line-height: 26px;
        background: rgba(255, 216, 0, 1);
        text-align: center;
        cursor: pointer;
        border-radius: 2px;
        color: #4E4E4E;
        position: absolute;
        left: 50%;
        top: 50%;
        z-index: 3;
        font-size: 14px;
        margin: -13px 0 0 -41px;
        transition: .3s ease-out;
    }

    .upload_success .upload_success_btn:hover {
        color: #fff;
        background-color: #cf7700;
        border-color: #cf7700;
    }

    .upload_text .upload_text_add {
        color: #A9A9A9;
        font-size: 40px;
        line-height: 1;
        margin-bottom: 9px;
    }

    /deep/ .ivu-input {
        width: 400px;
        height: 48px;
        /*border: 1px solid #CBCBCB;*/
        border-radius: 2px;
        box-shadow: none;
        font-size: 14px;
        line-height: 48px;
        color: #333;
        padding: 0 10px;
    }
    .upload_group .upload_desc {
        padding-top: 15px;
        color: #999999;
        font-size: 12px;
        line-height: 17px;
    }

    .upload_desc .demo_img {
        width: 327px;
        padding-top: 14px;
    }

    .upload_desc .demo_text {
        width: 335px;
        color: #666666;
        font-size: 12px;
        font-weight: bold;
        padding-top: 4px;
        display: flex;
        justify-content: space-around;
        list-style: none;
    }
    .item_content .img_group {
        display: flex;

        .id_card {
            display: block;
            width: 180px;
            height: 110px;
            margin-right: 20px;
            object-fit: cover;
            background: #f5f5f5;
        }

        .id_card:last-child {
            margin-right: 0;
        }

        .license_photo {
            display: block;
            width: 130px;
            height: 160px;
            object-fit: cover;
            background: #f5f5f5;
            margin-right: 20px;
        }

        .license_photo:last-child {
            margin-right: 0;
        }


    }


</style>
